import { render } from "./NoticePostView.vue?vue&type=template&id=5d13b70c"
import script from "./NoticePostView.vue?vue&type=script&lang=js"
export * from "./NoticePostView.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__